<template>
  <div class="body">
    <el-tabs v-model="activeName" type="border-card">
      <table cellspacing="0" cellpadding="0" class="csSpecialApplicationTable" style="width: 100%;">
        <tr>
          <td class="tableLabel">申请编号：</td>
          <td>{{csSpecialApplication.billNo}}</td>
          <td class="tableLabel">申请人：</td>
          <td>{{csSpecialApplication.creatorName}}</td>
          <td class="tableLabel">申请时间：</td>
          <td> {{csSpecialApplication.createTime}}</td>
        </tr>
        <tr>
          <td class="tableLabel">申请标题：</td>
          <td>{{csSpecialApplication.title}}</td>
          <td class="tableLabel">紧急程度：</td>
          <td>
            <el-radio-group v-model="csSpecialApplication.urgency" disabled>
              <el-radio :label="10">一般</el-radio>
              <el-radio :label="20">较急</el-radio>
              <el-radio :label="30">特急</el-radio>
            </el-radio-group>
          </td>
          <td class="tableLabel">申请类型：</td>
          <td>
            <el-select v-model="csSpecialApplication.cause" disabled placeholder="请选择申请类型">
              <el-option
                  v-for="item in constant.toSelect(constant.specialApplicationCause)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </td>
        </tr>
        <tr>
          <td class="tableLabel">售后单号：</td>
          <td>{{csSpecialApplication.afterSaleNo}}</td>
          <td class="tableLabel">客户单号：</td>
          <td>{{csSpecialApplication.customerBillNo}}</td>
          <td class="tableLabel">客户名称：</td>
          <td>{{csSpecialApplication.customerName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">出厂编号：</td>
          <td>{{csSpecialApplication.factorNo}}</td>
          <td class="tableLabel">电梯编号：</td>
          <td>{{csSpecialApplication.elevatorNo}}</td>
          <td class="tableLabel">项目名称：</td>
          <td>{{csSpecialApplication.projectName}}</td>
        </tr>
        <tr>
          <td class="tableLabel">现场描述：</td>
          <td colspan="5">{{csSpecialApplication.siteDesc}}</td>
        </tr>
      </table>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">物料信息</div>
      <el-table
          :data="csSpecialApplication.details">
        <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" placeholder="请输入">
              <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="materialName" align="center" label="物料名称">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialName" placeholder="请输入" autosize type="textarea"/>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" width="160" align="center" label="数量">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" placeholder="请输入"/>
          </template>
        </el-table-column>
        <el-table-column prop="unit" width="100" align="center" label="单位">
          <template slot-scope="scope">
            <el-input v-model="scope.row.unit" placeholder="请输入"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
        style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
      订单附件
    </div>
    <div
        style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
      <el-upload
          :action="actionUrl"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :on-error="handlerError"
          :file-list="files"
          :show-file-list="false">
        <el-button size="small" type="primary" style="margin: 0 5px 0 0">添加附件</el-button>
      </el-upload>
    </div>
    <el-table
        ref="payData1"
        :data="csSpecialApplication.attachments">
      <el-table-column type="index" align="center" label="行号"/>
      <el-table-column prop="fileName" align="center" label="图片">
        <template slot-scope="scope">
          <el-image
              style="width: 50px; height: 50px;margin-right: 10px"
              :src="scope.row.imgUrl"
              :preview-src-list="imgUrls"/>
        </template>
      </el-table-column>
      <el-table-column prop="fileName" align="center" label="附件描述">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.fileName"
              class="tabInput"
              style="width: 400px;margin: 0 auto;text-align: center"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="180" class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          <el-button type="danger" @click="oneDelete(scope.row,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import constants from "@/util/constants";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";
  import UserSelectWithIndex from "@/views/SystemInfo/SystemUser/UserSelectWithIndex";

  export default {
    name: "CsSpecialApprovePreview",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constant,
        constants,
        uploadLoading: false,
        saveLoading: false,
        photoVisible: false,
        files: [],
        imgUrls: [],
        fileList: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        nodeId: "",
        bigImgUrl: "",
        activeName: "first",
        selection: [],
        index: [],
        tableData: [
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 10,
            departmentName: "申请部门负责人",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 20,
            departmentName: "研发",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 30,
            departmentName: "技术部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 40,
            departmentName: "质量部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 50,
            departmentName: "客户质量管理部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 60,
            departmentName: "售后服务部",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 70,
            departmentName: "其他部门",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 80,
            departmentName: "总经理",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
          {
            pkid: 0,
            masterId: 0,
            isSelected: false,
            departmentNo: 90,
            departmentName: "董事长",
            releaseTime: "",
            approverId: 0,
            approverName: "",
            approveResult: "",
            approveTime: "",
          },
        ],
        csSpecialApplication: {
          pkid: "",
          billNo: "",
          afterSaleNo: "",
          title: "",
          customerBillNo: "",
          customerName: "",
          factorNo: "",
          elevatorNo: "",
          projectName: "",
          urgency: 10,
          cause: "",
          details:[],
          attachments:[],
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.toDoApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.getNodeValue();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `csSpecialApplications/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.csSpecialApplication = resp;
            this.csSpecialApplication.attachments.forEach(row => {
              if (row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              } else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            console.log(this.imgUrls);
          });
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo / 10) - 1);
        }
      },

      selectDealMan(index, row) {
        console.log(index,row);
        this.tableData[index].approverId = row.systemUserID;
        this.tableData[index].approverName = row.employeeName;
      },
      //附件表页面删除
      oneDelete(row, index) {
        this.csSpecialApplication.attachments.splice(index, 1);
      },
      downLoad(row) {
        console.log(row);
        if (row.filePath.includes("common")) {
          let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
          let a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        } else {
          let a = document.createElement("a");
          a.href = "http://emes.stepelectric.com" + row.filePath;
          a.target = "_blank";
          a.download = row.filePath;
          a.style.display = "none";
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        }
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      handleSuccess(response, file, fileList) {
        console.log(file);
        file.path = response;
        this.files = fileList;
        let object = {
          fileName: file.path.originalName,
          filePath: file.path.fullPath,
        };
        this.csSpecialApplication.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      toDoApprove() {
        console.log(this.params);
        if (this.params.actionType === 0) {
          if (this.nodeId === "qualityApprove") {
            // if (this.csSpecialApplication.dutyHandleId === "") {
            //   return this.$message.error("请选择责任处理人");
            // }
            // this.params.applicationVarVOS[0].varValue = this.csSpecialApplication.dutyHandleId + "";
            this.toSave();
          }
          if (this.nodeId === "zApprove") {
            this.updateReplacementBill();
          }
        }
        if (this.params.actionType === 2) {
          this.updateStatus();
        }
        let approveVar = "";
        if (this.params.actionType === 0) {
          let list = this.params.applicationVarVOS;
          if (list.length > 0) {
            for (let i = 0; i < list.length; i++) {
              if (i === list.length - 1) {
                approveVar += list[i].varName + "#" + list[i].varValue;
              } else {
                approveVar += list[i].varName + "#" + list[i].varValue + "|";
              }
            }
          }
        }
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          transferTo: this.params.transferTo,
          approveVar: approveVar,
          billParam: "",
        };
        this.doApprove(params);
      },
      toSave() {
        this.saveLoading = true;
        this.$http
          .put("basic", "csSpecialApplications", this.csSpecialApplication)
          .then(() => {
            this.$message.success("保存成功");
            this.saveLoading = false;
          }).catch(() => {
            this.saveLoading = false;
          });
      },
      doApprove(params) {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/csSpecialApprove",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.csSpecialApplication.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      // 物料选择对话框
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      updateStatus() {
        this.$http
          .get("basic", `csSpecialApplications/back/${this.csSpecialApplication.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      updateReplacementBill() {
        this.$http
          .get("basic", `replacementBills/updateBillStatus/${this.csSpecialApplication.afterSaleNo}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      getNodeValue() {
        let params = {
          "billType": this.billType,
          "billId": this.billId,
          "sequId": this.sequId,
        };
        this.$http
          .get("basic", "applications/approve", params)
          .then(resp => {
            this.nodeId = resp.nodeId;
            if (this.nodeId === "conference") {
              this.activeName = "second";
            } else {
              this.activeName = "first";
            }
          });
      },
    },
  };
</script>
<style lang="scss">
table.csSpecialApplicationTable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}

table.csSpecialApplicationTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}

table.csSpecialApplicationTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}

.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
